import { xor } from 'lodash';
import { connect } from 'react-redux';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';

TaskFilter.defaultProps = {
  selectedTaskIds: [],
};

const mapStateToProps = (state, ownProps) => ({
  tasks: selectImpactedEntities(ownProps.id)(state).impactTasks,
});

function TaskFilter({ selectedTaskIds, tasks, navigateAction }) {
  const selectedCount = selectedTaskIds.length;

  const handleSelect = useCallback(
    (taskId) =>
      navigateAction({
        taskIds: taskId ? xor(selectedTaskIds, [taskId]) : [],
      }),
    [selectedTaskIds]
  );

  const renderMenuItem = useCallback(
    (task) => {
      return (
        <React.Fragment key={task.id}>
          <MenuItem
            onSelect={handleSelect}
            active={selectedTaskIds.includes(task.id)}
            eventKey={task.id}
          >
            {task.title}
          </MenuItem>
        </React.Fragment>
      );
    },
    [selectedTaskIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Task Title</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="tasks-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {[...new Set(tasks.map((item) => item.name))].map((p, index) => (
            <React.Fragment key={index}>
              <MenuItem header>{p}</MenuItem>
              {tasks.filter((t) => t.name === p).map(renderMenuItem)}
              <MenuItem divider />
            </React.Fragment>
          ))}
          <MenuItem divider />
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(TaskFilter);
